<template>
  <div class="wg-row">
    <!-- Dialog cancellazione stampante -->
    <wg-modal v-if="showDeleteModal" @closeModal="cancelDelete">
      <div class="wg-row" style="justify-content:center;" slot="body">
        <div
          class="com-anm22-app-text-xl"
        >{{ $anm22.strLang(lang, 'Delete printer?', 'Cancellare stampante?') }}</div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row" style="align-items:center;justify-content:center;">
          <input
            type="button"
            class="small com-anm22-button-blue"
            :value="$anm22.strLang(lang, 'OK', 'OK')"
            @click="deletePrinter"
          >
          <div class="com-anm22-app-horizontal-space" style="width:20px;"></div>
          <input
            type="button"
            class="small com-anm22-button-red"
            :value="$anm22.strLang(lang, 'Cancel', 'Annulla')"
            @click="cancelDelete"
          >
        </div>
      </div>
    </wg-modal>
    <!-- Dialog modifica -->
    <wg-modal :width="windowWidth > 771 ? '400px' : '90%'" v-if="showPrinterModal" @closeModal="closePrinter">
      <div slot="header" class="com-anm22-app-text-xl">
        {{ selected.idPrinter 
            ? $anm22.strLang(lang, 'Edit printer', 'Modifica stampante') 
            : $anm22.strLang(lang, 'New printer', 'Nuova stampante') 
        }}
      </div>
      <div slot="body" class="wg-row">
        <div class="wg-row">
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, 'Name', 'Nome') }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input 
              type="text"
              :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
              v-model="selected.name">  
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, 'Model', 'Modello') }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <select class="com-anm22-app-select" @change="modelError = '';" v-model="selected.model">
            <option hidden disabled value="">{{ $anm22.strLang(lang, 'Select one', 'Selezionare') }}</option>
            <option 
                v-for="(mc, index) in modelClasses"
                :key="'mc-'+index"
                :value="mc.id">
              {{ mc.name }}
            </option>
          </select> 
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, 'IP address', 'Indirizzo IP') }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input 
              type="text"
              :placeholder="$anm22.strLang(lang, 'IP', 'IP')"
              v-model="selected.ip">  
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, 'Port', 'Porta') }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input 
              type="text"
              :placeholder="$anm22.strLang(lang, 'Port', 'Porta')"
              v-model="selected.port">  
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, 'SSL', 'SSL') }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <div class="wg-row">
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
              <input
                id="ssl"
                type="checkbox"
                style="display:none;"
                v-model="selected.ssl"
              />
              <label
                class="label-input-radio"
                for="ssl"
              >{{ selected.ssl ? '✔' : '' }}</label>
            </div>
          </div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, 'Mode', 'Modalità') }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <div class="wg-row">
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
              <input
                id="mode-f"
                type="checkbox"
                style="display:none;"
                v-model="selected.printMode.fis"
              />
              <label
                class="label-input-radio"
                for="mode-f"
              >{{ selected.printMode.fis ? '✔' : '' }}</label>
              <div
                class="com-anm22-app-text-m"
                style="margin:0 5px;"
              >{{ $anm22.strLang(lang, 'Fiscal', 'Fiscale') }}</div>
            </div>
            <div class="vertical-height-div" style="height:5px;"></div>
            <div class="wg-row">
              <div
                class="com-anm22-app-text-s"
                style="opacity:0.7;"
              >{{ '*La modalità fiscale è tale solo se la stampante è stata fiscalizzata.' }}</div>
            </div>
            <div class="vertical-height-div" style="height:5px;"></div>
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
              <input
                id="mode-nf"
                type="checkbox"
                style="display:none;"
                v-model="selected.printMode.nfis"
              />
              <label
                class="label-input-radio"
                for="mode-nf"
              >{{ selected.printMode.nfis ? '✔' : '' }}</label>
              <div
                class="com-anm22-app-text-m"
                style="margin:0 5px;"
              >{{ $anm22.strLang(lang, 'Non fiscal', 'Non fiscale') }}</div>
            </div>
            <div class="vertical-height-div" style="height:5px;"></div>
            <template v-if="license.config.modules.sequences.enabled">
              <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
                <input
                  id="mode-l"
                  type="checkbox"
                  style="display:none;"
                  v-model="selected.printMode.list"
                />
                <label
                  class="label-input-radio"
                  for="mode-l"
                >{{ selected.printMode.list ? '✔' : '' }}</label>
                <div
                  class="com-anm22-app-text-m"
                  style="margin:0 5px;"
                >{{ $anm22.strLang(lang, 'List', 'Comande') }}</div>
              </div>
              <div class="vertical-height-div" style="height:5px;"></div>
            </template>
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
              <input
                id="mode-t"
                type="checkbox"
                style="display:none;"
                v-model="selected.printMode.text"
              />
              <label
                class="label-input-radio"
                for="mode-t"
              >{{ selected.printMode.text ? '✔' : '' }}</label>
              <div
                class="com-anm22-app-text-m"
                style="margin:0 5px;"
              >{{ $anm22.strLang(lang, 'Text', 'Testo') }}</div>
            </div>
          </div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, 'Departments', 'Reparti') }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <div class="wg-row">
            <div
              class="com-anm22-app-text-s"
              style="opacity:0.7;"
            >{{ '*Impostare aliquota IVA del reparto.' }}</div>
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
            <div
              class="com-anm22-app-text-m"
              style="margin:0 5px;"
            >1</div>
            <input
              type="text"
              style="width:50px;"
              :value="selected.departments[0]"
              @change="validateDepartment($event.target.value, 0)"
            />
            <div
              class="com-anm22-app-text-m"
              style="margin:0 5px;"
            >%</div>
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
            <div
              class="com-anm22-app-text-m"
              style="margin:0 5px;"
            >2</div>
            <input
              type="text"
              style="width:50px;"
              :value="selected.departments[1]"
              @change="validateDepartment($event.target.value, 1)"
            />
            <div
              class="com-anm22-app-text-m"
              style="margin:0 5px;"
            >%</div>
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
            <div
              class="com-anm22-app-text-m"
              style="margin:0 5px;"
            >3</div>
            <input
              type="text"
              style="width:50px;"
              :value="selected.departments[2]"
              @change="validateDepartment($event.target.value, 2)"
            />
            <div
              class="com-anm22-app-text-m"
              style="margin:0 5px;"
            >%</div>
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
            <div
              class="com-anm22-app-text-m"
              style="margin:0 5px;"
            >4</div>
            <input
              type="text"
              style="width:50px;"
              :value="selected.departments[3]"
              @change="validateDepartment($event.target.value, 3)"
            />
            <div
              class="com-anm22-app-text-m"
              style="margin:0 5px;"
            >%</div>
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
            <div
              class="com-anm22-app-text-m"
              style="margin:0 5px;"
            >5</div>
            <input
              type="number"
              style="width:50px;"
              :value="selected.departments[4]"
              @change="validateDepartment($event.target.value, 4)"
            />
            <div
              class="com-anm22-app-text-m"
              style="margin:0 5px;"
            >%</div>
          </div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, 'Header', 'Intestazione') }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input 
              type="text"
              :placeholder="$anm22.strLang(lang, 'Header', 'Intestazione')"
              v-model="selected.header">  
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, 'Header 2', 'Intestazione 2') }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input 
              type="text"
              :placeholder="$anm22.strLang(lang, 'Header', 'Intestazione')"
              v-model="selected.header2">  
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, 'Footer', 'Piè di pagina') }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input 
              type="text"
              :placeholder="$anm22.strLang(lang, 'Footer', 'Testo')"
              v-model="selected.footer">  
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <template v-if="modelError">
          <div class="wg-row com-anm22-app-text-m" style="color:red;">
            {{ modelError }}
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
        </template>
        <div class="wg-row">
          <input 
              type="button" 
              :value="$anm22.strLang(lang, 'Save', 'Salva')" 
              @click="save">
        </div>
      </div>
    </wg-modal>
    <div class="com-anm22-page-title" style="font-size:24px;">
      {{ $anm22.strLang(lang, 'Printers', 'Stampanti') }}
    </div>
    <!-- Toggle printer master -->
    <template v-if="license.config.modules.sequences.enabled">
      <div class="wg-row" style="align-items:center;">
        <div class="com-anm22-app-text-l" style="margin-right:10px;">
          Master:
        </div>
        <div class="com-anm22-app-text-l" :style="{color: isPrinterMaster ? '#00af87' : 'red', marginRight: '20px'}">
          {{ isPrinterMaster ? $anm22.strLang(lang, 'Yes', 'Sì') : 'No' }}
        </div>
        <input
            type="button"
            class="small"
            style="margin-right:20px;"
            :value="!isPrinterMaster ? $anm22.strLang(lang, 'Set', 'Attiva') : $anm22.strLang(lang, 'Unset', 'Disattiva')"
            @click="togglePrinterMaster"
        >
        <div v-if="lastPing" class="com-anm22-app-text-l" >
          {{ $anm22.strLang(lang, 'Last request: ', 'Ultima richiesta: ') + $moment.tz(lastPing, "X", timezone).format('YYYY-MM-DD HH:mm') }}
        </div>
      </div>
      <div class="vertical-height-div" style="height:5px;"></div>
      <div class="wg-row">
        <div
          class="com-anm22-app-text-s"
          style="opacity:0.7;"
        >{{ '*Attivare questa opzione presso il punto cassa che controlla la stampa delle comande della cucina.' }}</div>
      </div>
    </template>
    <div class="wg-row" style="margin: 20px 0;">
      <input
          type="button"
          class="small"
          :value="$anm22.strLang(lang, 'Cancel tickets', 'Brucia comande')"
          @click="emptyPrintQueue"
      >
    </div>
    <!-- Lista stampanti -->
    <div class="wg-row" style="align-items:center;">
      <div 
          v-for="(printer,index) in printers"
          :key="'printer-'+index"
          class="wg-row printer-container"
          @click="editPrinter(printer.idPrinter)">
        <div class="wg-col wg-xs-1 display-flex" style="justify-content:center;">
          <img 
              :src="modelClasses.find(mc => mc.id == printer.model).img"
              class="com-anm22-app-img-fixed-height-l"
              style="align-self:center;"
          >
        </div>
        <div class="wg-col wg-xs-10" style="margin-right:10px;">
          <div class="wg-row">
            <div class="com-anm22-app-text-xxl">{{ 
              printer.name + ' - ' + modelClasses.find(mc => mc.id == printer.model).name
            }}</div>
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <div class="wg-row" style="opacity:0.7;">
            <div class="com-anm22-app-text-m">{{ 
              (printer.printMode.fis ? 'F ' : '') +
              (printer.printMode.nfis ? 'N ' : '') +
              (printer.printMode.list ? 'L ' : '') +
              (printer.printMode.text ? 'T ' : '') +
              ' - ' + printer.ip + ':' + printer.port 
            }}</div>
          </div>
        </div>
        <div class="wg-col wg-xs-1 display-flex" style="justify-content:center;">
          <img 
              :src="$anm22.icons.getWorldIcon('deleteBlack')"
              class="com-anm22-app-img-s"
              @click.stop="initDelete(printer.idPrinter)"
          >
        </div>
      </div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <input
        type="button"
        :value="$anm22.strLang(lang, 'Add printer', 'Aggiungi stampante')"
        @click="addPrinter"
    >
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      lastPing: null,
      selected: null,
      showPrinterModal: false,
      showDeleteModal: false,
      toDelete: null,
      modelError: '',
      /* printer Models */
      modelClasses: [
        {
          id: '31',
          name: 'Coristech PrintF!',
          img: 'https://world.anm22.it/app/yourbeach/images/printers/coristech.jpg'
        },
        {
          id: '41',
          name: 'Custom',
          img: 'https://world.anm22.it/app/yourbeach/images/printers/custom.jpg'
        },
        {
          id: '42',
          name: 'Custom RAW',
          img: 'https://world.anm22.it/app/yourbeach/images/printers/custom.jpg'
        },
        {
          id: '43',
          name: 'Custom ESC/POS™',
          img: 'https://world.anm22.it/app/yourbeach/images/printers/custom.jpg'
        },
        {
          id: '44',
          name: 'Custom Remote',
          img: 'https://world.anm22.it/app/yourbeach/images/printers/custom.jpg'
        },
        {
          id: '21',
          name: 'EPSON FP81ii',
          img: 'https://world.anm22.it/app/yourbeach/images/printers/epson.jpg'
        },
        {
          id: '22',
          name: 'EPSON TMP80',
          img: 'https://world.anm22.it/app/yourbeach/images/printers/epson.jpg'
        },
        {
          id: '23',
          name: 'EPSON TM-T20ii',
          img: 'https://world.anm22.it/app/yourbeach/images/printers/epson.jpg'
        },
        {
          id: '11',
          name: 'Olivetti Nettun@7000 (old-driver)',
          img: ''
        },
        {
          id: '12',
          name: 'Olivetti Nettun@7000 (old-driver v2)',
          img: ''
        },
        {
          id: '13',
          name: 'Olivetti Nettuna 300',
          img: ''
        },
        {
          id: '14',
          name: 'Olivetti PRT200FX (old-driver)',
          img: ''
        },
        {
          id: '15',
          name: 'Olivetti PRT200FX',
          img: ''
        },
        {
          id: '16',
          name: 'Olivetti Nettun@7000',
          img: ''
        },
        {
          id: '2',
          name: 'RCH PrintF!',
          img: 'https://world.anm22.it/app/yourbeach/images/printers/rch.jpg'
        }
      ]
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      licenseSelected: state => state.licenseSelected,
      windowWidth: state => state.windowWidth,
      windowHeight: state => state.windowHeight,
      isOffline: state => state.offline.isOffline,
      isPrinterMaster: state => state.isPrinterMaster
    }),
    license() {
      return this.$store.getters['foodLicenses/getByHash'](this.licenseSelected);
    },
    work() {
      return this.$store.getters["works/get"](this.license.work);
    },
    timezone() {
      return this.work.timezone;
    },
    employment() {
      return this.$store.getters["foodEmployments/get"](
        this.license.id + "-" + this.user.idWorldUser
      );
    },
    permission() {
      return this.employment ? this.employment.permission : 6;
    },
    printers() {
      return this.$store.getters['foodPrinters/getByLicense'](this.license.id)
    }
  },
  methods: { 
    togglePrinterMaster() {
      if(this.isPrinterMaster) {
        this.$anm22.setCookie('food_printer_master', '', -1);
        this.$store.dispatch('setIsPrinterMaster', false);
      } else {
        this.$anm22.setCookie('food_printer_master', 1, 31536000);
        this.$store.dispatch('setIsPrinterMaster', true);
      }
    },
    validateDepartment(value, index) {
      let dep = Number(value);
      if(dep < 0) {
        dep = 0;
      } else if(dep > 100) {
        dep = 100;
      }
      this.$set(this.selected.departments, index, dep);
    },
    addPrinter() {
      const printer = {
        model: '',
        departments: [],
        printMode: {
          fis: false,
          nfis: false,
          list: false,
          text: false
        }
      };
      this.selected = printer;
      this.showPrinterModal = true;
    },
    editPrinter(pid) {
      this.selected = {...this.printers.find(p => p.idPrinter === pid)};
      this.showPrinterModal = true;
    },
    closePrinter() {
      this.showPrinterModal = false;
      this.selected = null;
    },
    save() {
      if(!this.selected.model || this.selected.model === ''){
        //Mostro errore e impedisco il salvataggio
        this.modelError = this.$anm22.strLang(
          this.lang,
          "No model as been selected for the printer",
          "Non è stato selezionato nessun modello per la stampante"
        );
        return;
      }
      this.$http.post('settings/save-printer', {
        printer: this.selected
      })
        .then(response => {
          this.$store.dispatch('foodPrinters/update', {
            vlf: this.$vlf('foodPrinters'), objs: [response.data.printer]
          })
            .then(() => {
              this.closePrinter();
            });
        })
        .catch(e => console.log(e));
    },
    initDelete(pid) {
      this.toDelete = this.printers.find(p => p.idPrinter === pid);
      this.showDeleteModal = true;
    },
    cancelDelete() {
      this.showDeleteModal = false;
      this.toDelete = null;
    },
    deletePrinter() {
      this.showDeleteModal = false;
      this.$http.post('settings/delete-printer', {
        idPrinter: this.toDelete.idPrinter
      })
        .then(response => {
          this.$store.dispatch('foodPrinters/delete', {
            vlf: this.$vlf('foodPrinters'), obj: this.toDelete
          });
        })
        .catch(e => console.log(e));
    },
    async emptyPrintQueue() {
      const response = await this.$http.post('printer-queue/empty-queue');
      this.$anm22.eventBus.$emit("world-headbar-show-message", {
        text: this.$anm22.strLang(
          this.lang,
          "Operation completed",
          "Operazione completata"
        ),
        type: "confirm"
      });
    }
  },
  created() {
    // Blocco l'accesso se ho un permesso di basso livello o se la licenza è una delle demo e il permesso non è superuser
    if(this.permission > 3 
        || (this.permission !== 1 && (this.license.work === 1 || this.license.work === 2 || this.license.work === 289))) {
      this.$router.push('/').catch(e => console.log(e));
      return;
    }
    this.$http.get('settings/printers')
      .then(response => {
        this.lastPing = response.data.lastPing;
        this.$store.dispatch("foodPrinters/update", {
          vlf: this.$vlf("foodPrinters"),
          objs: response.data.printers
        })
        .then(() => {
          this.$Progress.finish();
        })
      });
  }
}
</script>

<style lang="scss" scoped>
.printer-container {
  flex-wrap:nowrap;
  align-items:center;
  margin-bottom:10px;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #ddd;
  cursor: pointer;
  &:hover {
    background-color: #eee;
  }
}
.label-input-radio {
  display: block;
  height: 20px;
  width: 20px;
  border: 1px solid #bbb;
  border-radius: 4px;
  font-size: 16px;
  padding: 1px 2px;
  cursor: pointer;
}
</style>
